module.exports = __webpack_public_path__ + "img/sv12.39d81dd4.svg";